const cartItems = document.querySelectorAll("input.quantity__input");
const cartNote = document.querySelector(".cart__note");

if (cartItems) {
  cartItems.forEach((cartItemInput) => {
    // Ensure Dawn's theme for quantity input field can't be manually updated
    cartItemInput.disabled = true;

    // If certification, show cart note.
    if (cartItemInput.classList.contains('certification') && cartNote) {
      cartNote.classList.remove('hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  let agree = document.querySelector('#agree');
  let checkout = document.querySelector('#checkout');

  agree.addEventListener('click', function(e) {
    if (agree.checked) {
      checkout.disabled = false;
    } else {
      checkout.disabled = true;
    }
  });
});

/* QR Upgrades */
function addQR(productID) {
    fetch(window.Shopify.routes.root + 'cart/add.js',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'items': [
                    {
                        'id': productID,
                        'quantity': 1
                    }]
            })
        }).then(response => response.json())
        .then(function (response) {
            const quantity = document.querySelector('#cart-icon-bubble > div > span:nth-child(1)');

            fetch(window.Shopify.routes.root + 'cart.js')
                .then(res => res.json())
                .then(data => {
                    const cartQuantity = data.item_count;
                    quantity.textContent = cartQuantity;

                    let cartItemsContainer = document.querySelector('.cart-items tbody');

                    cartItemsContainer.innerHTML = '';

                    data.items.forEach((product, index) => {
                        const formattedPrice = product.presentment_price.toFixed(2);

                        const itemHTML = `
        <tr class="cart-item" id="CartItem-${index + 1}">
          <td class="cart-item__media">
              <a href="${product.url}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
              <div class="cart-item__image-container gradient global-media-settings">
                  <img src="${product.image}" class="cart-item__image" alt="" loading="lazy" width="150" height="150">
              </div>
          </td>
          <td class="cart-item__details">
              <a href="/products/${product.handle}?variant=${product.id}" class="cart-item__name h4 break">${product.title}</a>
              <div class="product-option">$${formattedPrice}</div>
              <dl></dl>
              <p class="product-option"></p>
              <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
          </td>
          <td class="cart-item__totals right medium-hide large-up-hide">
              <div class="loading-overlay hidden">
                  <div class="loading-overlay__spinner">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                  </div>
              </div>
              <div class="cart-item__price-wrapper"><span class="price price--end">$${formattedPrice}</span></div>
          </td>
          <td class="cart-item__quantity">
                      <quantity-popover>
                        <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                          <label class="visually-hidden" for="Quantity-${index + 1}">
                            Quantity
                          </label>
                          <div class="quantity-popover-container"><quantity-input class="quantity cart-quantity">
                              <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                                <span class="visually-hidden">Decrease quantity for ${product.title}</span>
                                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
  </path></svg></span>

                              </button>
                              <input class="quantity__input" data-quantity-variant-id="48354793521453" type="number" name="updates[]" value="1" data-cart-quantity="1" min="1" step="1" aria-label="Quantity for ${product.title}" id="Quantity-${index + 1}" data-index="${index + 1}" disabled="">
                              <button class="quantity__button no-js-hidden" name="plus" type="button">
                                <span class="visually-hidden">Increase quantity for ${product.title}</span>
                                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
  </path></svg></span>

                              </button>
                            </quantity-input>
                          </div>
                          <cart-remove-button id="Remove-${index + 1}" data-index="${index + 1}">
                            <a href="/cart/change?id=48354793521453:1be8124094ba9acd4c98feca3fa71982&amp;quantity=0" class="button button--tertiary" aria-label="Remove ${product.title}">
                              <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
  </svg></span>

                            </a>
                          </cart-remove-button>
                        </div><div class="cart-item__error" id="Line-item-error-${index + 1}" role="alert">
                          <small class="cart-item__error-text"></small>
                          <span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                          </path></svg></span>
                        </div>
                      </quantity-popover>
                    </td>
          <td class="cart-item__totals right small-hide">
              <div class="loading-overlay hidden">
                  <div class="loading-overlay__spinner">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                  </div>
              </div>
              <div class="cart-item__price-wrapper"><span class="price price--end">$${formattedPrice}</span></div>
          </td>
      </tr>
      `;

                        cartItemsContainer.innerHTML += itemHTML;
                    });
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }).catch((error) => {
            console.error('Error:', error);
        });
}
